class BasicAnalysisCtrl
  constructor: (@$scope, ScoreCardAPIService, $routeParams) ->
    @basicAnalysisData =
      goal: @$scope.$parent.goalSettings
      my_avg: undefined
      all_members: undefined

    params =
      user_id: $routeParams.user_id

    ScoreCardAPIService.getAllMembers(params).then (data) =>
      @basicAnalysisData.all_members = data

    @$scope.$on "myAnalysisUpdated.gnp.analysis", (event, myAnalysis) =>
      @basicAnalysisData.my_avg = myAnalysis.my_avg

BasicAnalysisCtrl.$inject = [
  '$scope'
  'ScoreCardAPIService'
  '$routeParams'
]

module.exports = BasicAnalysisCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/analysis/basic-analysis/basic-analysis-controller.coffee